export default __webpack_public_path__ + "static/media/arrowLeftShadow.a4f2d61c.svg";